import { render, staticRenderFns } from "./unpublishOpportunity.vue?vue&type=template&id=0b15cbd9&scoped=true"
import script from "./unpublishOpportunity.vue?vue&type=script&lang=js"
export * from "./unpublishOpportunity.vue?vue&type=script&lang=js"
import style0 from "./unpublishOpportunity.vue?vue&type=style&index=0&id=0b15cbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15cbd9",
  null
  
)

export default component.exports